import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"

import { Link } from "react-router-dom"

import { Header } from "ui-Text"
import { Container, Row, Col } from "ui-Grid"

import SocialLink from "ui-SocialLink"

const styleSheet = theme => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    padding: [theme.spacing.unit * 4, 0],

    "& a": {
      color: "inherit",
    },
  },

  logo: {
    height: theme.spacing.unit * 8,
  },

  socialLink: {
    margin: [0, theme.spacing.unit * 2, theme.spacing.unit * 2, 0],
  },

  socialLinks: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "flex-end",
    },
  },

  linkList: {
    ...theme.typography.caption,
    color: "inherit",
    listStyle: "none",
    padding: "0",

    "& > li": {
      margin: [theme.spacing.unit * 2, 0],
    },

    "& a": {
      textDecoration: "none",
    },
  },

  [theme.breakpoints.down("sm")]: {
    logoCol: {
      order: 1,
    },

    socialLinksCol: {
      order: 1,
    },

    linksCol: {
      order: 2,
    },
  },
})

function FooterContact({ classes }) {
  return (
    <nav className={classes.root}>
      <Container wide>
        <Row>
          <Col xs={12} sm={8} md={3} className={classes.logoCol}>
            <img
              src={require("../../../../static/images/logo-inverse.svg")}
              className={classes.logo}
              alt="JA Lactation Support Logo"
            />
          </Col>
          <Col xs={12} sm={12} md={6} className={classes.linksCol}>
            <Row gutterBottom>
              <Col xs={12} sm>
                <Header color="inherit">Services</Header>
                <ul className={classes.linkList}>
                  <li>
                    <Link to="/breastfeeding-support">Breastfeeding Support</Link>
                  </li>
                  <li>
                    <Link to="/breastfeeding-support/in-home-consultation">
                      In Home Consultation
                    </Link>
                  </li>
                  <li>
                    <Link to="/breastfeeding-support/prenatal-consultation">
                      Prenatal Consultation
                    </Link>
                  </li>
                  <li>
                    <Link to="/breastfeeding-support/weight-check">Weight Check</Link>
                  </li>
                </ul>
              </Col>
              <Col xs={12} sm>
                <Header color="inherit">Legal</Header>
                <ul className={classes.linkList}>
                  <li>
                    <Link to="/forms">Forms</Link>
                  </li>
                  <li>
                    <a href="/forms/consent.pdf" download>Consent Form</a>
                  </li>
                  <li>
                    <a href="/forms/hipaa.pdf" download>HIPAA Notice</a>
                  </li>
                </ul>
              </Col>
              <Col xs={12} sm>
                <Header color="inherit">Support</Header>
                <ul className={classes.linkList}>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                  <li>
                    <a href="mailto:julie@jalactation.com">julie@jalactation.com</a>
                  </li>
                  <li>
                    <a href="tel:9515266870">951-526-6870</a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
          <Col xs={12} sm={4} md={3} className={classes.socialLinksCol}>
            <div className={classes.socialLinks}>
              <SocialLink network="facebook" className={classes.socialLink} />
              <SocialLink network="instagram" className={classes.socialLink} />
              <SocialLink network="twitter" className={classes.socialLink} />
              <SocialLink network="google" className={classes.socialLink} />
            </div>
          </Col>
        </Row>
      </Container>
    </nav>
  )
}

export default withStyles(styleSheet)(FooterContact)



// WEBPACK FOOTER //
// ./src/views/chrome/MainAppChrome/FooterContact.js